/**
 * QuickZip Variant Controller Initialization
 * Handles integration with existing theme systems and provides debug utilities
 */

(function(global) {
  'use strict';

  // Debug helper
  global.qzDebugVariants = function() {
    console.log('=== QuickZip Variant Controller Debug ===');
    
    var forms = document.querySelectorAll('[data-product-form]');
    console.log('Found', forms.length, 'product forms');
    
    forms.forEach(function(form, index) {
      console.log(`\n--- Form ${index + 1} (${form.id}) ---`);
      var controller = form._qzVariantController;
      
      if (controller) {
        console.log('Controller initialized:', true);
        console.log('Current variant:', controller.getCurrentVariant());
        console.log('Selected options:', controller.getSelectedOptions());
        console.log('Total variants:', controller.variants.length);
        console.log('Product options:', controller.options);
      } else {
        console.log('Controller initialized:', false);
      }
      
      // Check swatch elements
      var swatches = form.querySelectorAll('.swatch-element');
      console.log('Swatch elements found:', swatches.length);
      
      var availableSwatches = form.querySelectorAll('.swatch-element.available');
      var soldoutSwatches = form.querySelectorAll('.swatch-element.soldout');
      console.log('Available swatches:', availableSwatches.length);
      console.log('Soldout swatches:', soldoutSwatches.length);
    });
    
    console.log('\n=== Gallery Integration ===');
    console.log('qzApplyVariantImages available:', typeof global.qzApplyVariantImages);
    console.log('qzGalleryActive:', global.qzGalleryActive);
    
    console.log('\n=== Utility Functions ===');
    console.log('Call qzToggleDebugMode() to enable/disable debug logging');
    console.log('Call qzRefreshVariantControllers() to reinitialize all controllers');
    console.log('Call qzTestVariantSelection(formIndex, variantId) to test variant selection');
  };

  // Toggle debug mode
  global.qzToggleDebugMode = function() {
    if (global.localStorage) {
      var isDebug = localStorage.getItem('qzDebug');
      if (isDebug) {
        localStorage.removeItem('qzDebug');
        document.body.classList.remove('qz-debug');
        console.log('QuickZip debug mode: OFF');
      } else {
        localStorage.setItem('qzDebug', '1');
        document.body.classList.add('qz-debug');
        console.log('QuickZip debug mode: ON');
      }
    }
  };

  // Test variant selection
  global.qzTestVariantSelection = function(formIndex, variantId) {
    var forms = document.querySelectorAll('[data-product-form]');
    var form = forms[formIndex || 0];
    
    if (!form) {
      console.error('Form not found at index:', formIndex);
      return;
    }
    
    var controller = form._qzVariantController;
    if (!controller) {
      console.error('Controller not found for form');
      return;
    }
    
    console.log('Testing variant selection:', variantId);
    controller.selectVariant(variantId);
  };

  // Compatibility layer for existing theme scripts
  global.qzVariantCompatibility = {
    // Hook into existing selectCallback if it exists
    enhanceSelectCallback: function() {
      if (global.selectCallback && typeof global.selectCallback === 'function') {
        var originalCallback = global.selectCallback;
        global.selectCallback = function(variant, selector) {
          // Call original callback first
          var result = originalCallback.apply(this, arguments);
          
          // Then update our controller
          var form = selector && selector.product && selector.product.container;
          if (form && form._qzVariantController) {
            form._qzVariantController.selectVariant(variant.id);
          }
          
          return result;
        };
        console.log('Enhanced existing selectCallback for compatibility');
      }
    },

    // Prevent old Shopify OptionSelectors from initializing on our forms
    preventOldInitialization: function() {
      // Override Shopify.OptionSelectors constructor to check for our flag
      if (global.Shopify && global.Shopify.OptionSelectors) {
        var OriginalOptionSelectors = global.Shopify.OptionSelectors;
        global.Shopify.OptionSelectors = function(domIdPrefix, options) {
          var element = document.getElementById(domIdPrefix);
          var form = element && element.closest('[data-product-form]');
          
          // If this form is handled by our new system, don't initialize the old one
          if (form && (form.getAttribute('data-qz-variant-handled') === 'true' || form._qzVariantHandled)) {
            console.log('QZ Variant Controller: Prevented old OptionSelectors initialization on', domIdPrefix);
            return { 
              selectVariant: function() { return false; },
              updateSelectors: function() { return false; }
            };
          }
          
          // Otherwise, use the original constructor
          return new OriginalOptionSelectors(domIdPrefix, options);
        };
        
        // Copy over any static methods/properties
        for (var prop in OriginalOptionSelectors) {
          if (OriginalOptionSelectors.hasOwnProperty(prop)) {
            global.Shopify.OptionSelectors[prop] = OriginalOptionSelectors[prop];
          }
        }
        
        console.log('QZ Variant Controller: Enhanced Shopify.OptionSelectors to prevent conflicts');
      }
    },

    // Create selectCallback if it doesn't exist
    createSelectCallback: function() {
      if (!global.selectCallback) {
        global.selectCallback = function(variant, selector) {
          var form = selector && selector.product && selector.product.container;
          if (form && form._qzVariantController) {
            form._qzVariantController.selectVariant(variant.id);
          }
        };
        console.log('Created selectCallback for theme compatibility');
      }
    },

    // Initialize compatibility features
    init: function() {
      this.enhanceSelectCallback();
      this.createSelectCallback();
      this.preventOldInitialization();
    }
  };

  // Wait for DOM and then initialize compatibility
  function initCompatibility() {
    // Set debug mode from localStorage
    if (global.localStorage && localStorage.getItem('qzDebug')) {
      document.body.classList.add('qz-debug');
    }

    // Initialize compatibility layer
    global.qzVariantCompatibility.init();
    
    // Prevent old system conflicts
    global.qzVariantCompatibility.preventOldInitialization();

    // Listen for variant changes and trigger legacy events
    document.addEventListener('qz:variant:change', function(e) {
      var detail = e.detail;
      if (detail.variant) {
        // Trigger legacy events that other parts of the theme might listen for
        var legacyEvent = new CustomEvent('variantChange', {
          detail: { variant: detail.variant }
        });
        document.dispatchEvent(legacyEvent);

        // Also try to call any global variant change handlers
        if (global.onVariantChange && typeof global.onVariantChange === 'function') {
          global.onVariantChange(detail.variant);
        }
      }
    });

    console.log('QuickZip Variant Controller compatibility initialized');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompatibility);
  } else {
    setTimeout(initCompatibility, 10);
  }

  // Auto-run debug function after everything loads (if debug mode is on)
  global.addEventListener('load', function() {
    if (global.localStorage && localStorage.getItem('qzDebug')) {
      setTimeout(function() {
        console.log('Auto-running debug (debug mode is ON)...');
        global.qzDebugVariants && global.qzDebugVariants();
      }, 1000);
    }
  });

})(window);